import type { Firm } from '@domain/firm/model';
import type { Lawyer } from '@domain/lawyer/model';

/// 弁護士詳細ヘッダー・一覧の「注意表示」を組み立てる純粋ロジック。
///
/// 一括営業可否は backend の派生値 (`lawyer.bulk_sales_decision`: 本人 / 現所属事務所 /
/// 懲戒の OR 合成) をそのまま使い、ここで合成を再実装しない (spec 20260716)。ラベルは
/// `@domain/bulk-sales/labels` の lawyerBulkSalesSummaryLabel。競合注意は事務所由来
/// (`firm.is_competitor`) のみで、現行の表現を維持する。旧営業NG理由は理由の欠落を
/// 「!」で示す対象ではなくなった (read-only の遺産表示のみ)。

function isBlank(value: string | null | undefined): boolean {
  return !value || value.trim().length === 0;
}

/// 理由文字列を表示用に整える。空なら「理由未設定」を返す。
export function reasonOrUnset(value: string | null | undefined): string {
  return isBlank(value) ? '理由未設定' : value!.trim();
}

/// 一括営業の除外 (対象外 / 一部対象外) があるか。派生値の state だけを見る。
export function hasBulkSalesExclusion(lawyer: Pick<Lawyer, 'bulk_sales_decision'>): boolean {
  return lawyer.bulk_sales_decision.state !== 'target';
}

export function hasFirmCompetitorCaution(firm: Firm | null): boolean {
  return firm?.is_competitor === true;
}

/// 何らかの注意表示 (一括営業の除外 or 競合) が必要か。
export function hasSalesCaution(
  lawyer: Pick<Lawyer, 'bulk_sales_decision'>,
  firm: Firm | null,
): boolean {
  return hasBulkSalesExclusion(lawyer) || hasFirmCompetitorCaution(firm);
}

export function isFirmCompetitorReasonMissing(firm: Firm | null): boolean {
  return hasFirmCompetitorCaution(firm) && isBlank(firm?.competitor_reason);
}
